import { render, staticRenderFns } from "./icon.component.vue?vue&type=template&id=22dd22a7"
import script from "./icon.component.vue?vue&type=script&lang=js"
export * from "./icon.component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports